export default __webpack_public_path__ + "static/media/element_8.f3553cc9.webp";